document.addEventListener('gk:tabs:change', (event) => {
  const tabs = event.target;
  if (!(tabs instanceof HTMLElement)) return;
  const section = tabs.closest('[data-gk-purchase-selector]');
  if (!section) return;
  const active = tabs.querySelector('[role="tab"][aria-selected="true"]');
  const panel = active && document.getElementById(active.getAttribute('aria-controls'));
  if (!panel || !section.contains(panel)) return;
  const title = section.querySelector('.gk-section-header__title');
  const eyebrow = section.querySelector('.gk-section-header__eyebrow');
  if (title) title.textContent = panel.dataset.gkPurchaseTitle;
  if (eyebrow) eyebrow.textContent = panel.dataset.gkPurchaseEyebrow;
  const context = section.closest('[data-gk-purchase-context]');
  context?.querySelectorAll('[data-gk-purchase-trust]').forEach((strip) => {
    const visible = strip.dataset.gkPurchaseTrust === panel.dataset.gkPurchasePanel;
    strip.hidden = !visible;
    strip.inert = !visible;
  });
});

